function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 0H2C0.89 0 0.01 0.89 0.01 2L0 18C0 19.11 0.89 20 2 20H18C19.11 20 20 19.11 20 18V2C20 0.89 19.11 0 18 0ZM9 15H11V14H12C12.55 14 13 13.55 13 13V10C13 9.45 12.55 9 12 9H9V8H13V6H11V5H9V6H8C7.45 6 7 6.45 7 7V10C7 10.55 7.45 11 8 11H11V12H7V14H9V15ZM2 18H18V2H2V18Z",
  fill: "#999999"
});

var SvgMoneyTemplateIcon = function SvgMoneyTemplateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoneyTemplateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MoneyTemplateIcon.2fc1a3d2.svg";
export { ForwardRef as ReactComponent };